import type { TupleToUnion } from 'type-fest'

import type { ThemeHoverTextColor, ThemeTextColor } from '@mntn-dev/ui-theme'

import type { Inheritable } from '../../../types/inheritable.ts'

export type IconSize =
  | '5xs'
  | '4xs'
  | '3xs'
  | '2xs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | '5xl'
  | '6xl'
  | '7xl'
  | '8xl'
  | '9xl'
  | '10xl'
  | '11xl'
  | '12xl'
  | 'full'

export type InheritableIconSize = Inheritable<IconSize>

export const iconFillNames = ['solid', 'outline'] as const
export type IconFill = TupleToUnion<typeof iconFillNames>

export type IconColor = ThemeTextColor
export type IconHoverColor = ThemeHoverTextColor

export type IconStrokeWidth = '0' | '1' | '1.5' | '2'
